module.exports = __webpack_public_path__ + "img/banner-1.af5f8368.png";